var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { checkIsPlatform, getTestId } from '@airtel/air-design-system';
import { useEffect, useRef, useState } from 'react';
import { View } from 'react-native';
import { checkIfDateAreSame, checkMinAndMaxDate, clearCarousel, updateIsSelectedKey } from './SchedulingWidgetUtils';
import { SchedulingCarouselCard } from './components/scheduling-carousel-card';
import { SchedulingSlotListCard } from './components/scheduling-slot-list-card';
var CALENDAR_EVENTS = {
  dismissed: 'dismissed',
  set: 'set'
};
export var SchedulingWidgetComponent = props => {
  var _a;
  var onUserAction = props.onUserAction,
    title = props.title,
    _props$dataList = props.dataList,
    dataList = _props$dataList === void 0 ? [] : _props$dataList,
    slotListTitle = props.slotListTitle,
    callOutWidgetProps = props.callOutWidgetProps,
    actionCtaProps = props.actionCtaProps,
    showActionCta = props.showActionCta,
    onSlotPress = props.onSlotPress,
    onCarouselItemPress = props.onCarouselItemPress,
    onCalendarItemPressMetaData = props.onCalendarItemPressMetaData,
    onClearPressMetadata = props.onClearPressMetadata,
    testID = props.testID,
    selectedCarouselIdx = props.selectedCarouselIdx,
    _props$unSelectPrevio = props.unSelectPreviousSlot,
    unSelectPreviousSlot = _props$unSelectPrevio === void 0 ? false : _props$unSelectPrevio,
    restProps = __rest(props, ["onUserAction", "title", "dataList", "slotListTitle", "callOutWidgetProps", "actionCtaProps", "showActionCta", "onSlotPress", "onCarouselItemPress", "onCalendarItemPressMetaData", "onClearPressMetadata", "testID", "selectedCarouselIdx", "unSelectPreviousSlot"]);
  var defaultSelectedCarouselIdx = selectedCarouselIdx !== null && selectedCarouselIdx !== void 0 ? selectedCarouselIdx : 0;
  var carouselCardRef = useRef(null);
  var _useState = useState(checkIsPlatform('ios') ? true : false),
    visible = _useState[0],
    setVisible = _useState[1];
  var _useState2 = useState(dataList),
    carousel = _useState2[0],
    setCarousel = _useState2[1];
  var _useState3 = useState(dataList === null || dataList === void 0 ? void 0 : dataList[defaultSelectedCarouselIdx]),
    selectedCarousel = _useState3[0],
    setSelectedCarousel = _useState3[1];
  var _useState4 = useState(defaultSelectedCarouselIdx),
    selectedCarouselIndex = _useState4[0],
    setSelectedCarouselIndex = _useState4[1];
  var _useState5 = useState(actionCtaProps === null || actionCtaProps === void 0 ? void 0 : actionCtaProps.minimumDate),
    selectedDate = _useState5[0],
    setDate = _useState5[1];
  var showSlotList = (_a = selectedCarousel === null || selectedCarousel === void 0 ? void 0 : selectedCarousel.showSlotList) !== null && _a !== void 0 ? _a : true;
  useEffect(() => {
    if (defaultSelectedCarouselIdx >= 0 && defaultSelectedCarouselIdx < (dataList === null || dataList === void 0 ? void 0 : dataList.length)) {
      var _carousel = updateIsSelectedKey(dataList, defaultSelectedCarouselIdx);
      setCarousel(_carousel);
      setSelectedCarousel(dataList === null || dataList === void 0 ? void 0 : dataList[defaultSelectedCarouselIdx]);
      onCarouselItemPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(onCarouselItemPress, dataList === null || dataList === void 0 ? void 0 : dataList[defaultSelectedCarouselIdx]));
    }
  }, [dataList, defaultSelectedCarouselIdx]);
  useEffect(() => {
    setDate(actionCtaProps === null || actionCtaProps === void 0 ? void 0 : actionCtaProps.minimumDate);
  }, [actionCtaProps]);
  var onSelectCarousel = (carouselItem, carouselIndex) => {
    var _a, _b, _c;
    var _carousel = updateIsSelectedKey(carousel, carouselIndex);
    var updatedCarousel = _carousel === null || _carousel === void 0 ? void 0 : _carousel.map(carouselItem => {
      var _a;
      var slots = (_a = carouselItem === null || carouselItem === void 0 ? void 0 : carouselItem.slotList) === null || _a === void 0 ? void 0 : _a.map(slotItem => {
        slotItem.isDisabled = false;
        return slotItem;
      });
      return Object.assign(Object.assign({}, carouselItem), {
        slotList: slots
      });
    });
    if (showActionCta) {
      var _selectedDate = carouselItem === null || carouselItem === void 0 ? void 0 : carouselItem.value;
      setDate(_selectedDate);
    }
    if (unSelectPreviousSlot) {
      updatedCarousel = _carousel === null || _carousel === void 0 ? void 0 : _carousel.map(carouselItem => {
        var _a;
        var slots = (_a = carouselItem === null || carouselItem === void 0 ? void 0 : carouselItem.slotList) === null || _a === void 0 ? void 0 : _a.map(slotItem => {
          if (carouselIndex !== selectedCarouselIndex) {
            slotItem.isSelected = false;
          }
          return slotItem;
        });
        return Object.assign(Object.assign({}, carouselItem), {
          slotList: slots
        });
      });
    }
    setCarousel(updatedCarousel);
    setSelectedCarousel(carouselItem);
    setSelectedCarouselIndex(carouselIndex);
    (_c = (_b = (_a = carouselCardRef === null || carouselCardRef === void 0 ? void 0 : carouselCardRef.current) === null || _a === void 0 ? void 0 : _a.carouselRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.scrollToIndex({
      animated: true,
      index: carouselIndex
    });
    onCarouselItemPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(onCarouselItemPress, carouselItem));
  };
  var onSelectSlot = (slot, slotIndex) => {
    var updatedCarousel = carousel === null || carousel === void 0 ? void 0 : carousel.map((carouselItem, index) => {
      var _a;
      var slots = [];
      if (index === selectedCarouselIndex) {
        slots = updateIsSelectedKey(carouselItem === null || carouselItem === void 0 ? void 0 : carouselItem.slotList, slotIndex);
      } else {
        slots = (_a = carouselItem === null || carouselItem === void 0 ? void 0 : carouselItem.slotList) === null || _a === void 0 ? void 0 : _a.map(slotItem => {
          slotItem.isSelected = false;
          return slotItem;
        });
      }
      return Object.assign(Object.assign({}, carouselItem), {
        slotList: slots
      });
    });
    setCarousel(updatedCarousel);
    onSlotPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(onSlotPress, slot));
  };
  var onCalendarOpen = () => {
    var _a, _b, _c, _d;
    !checkIsPlatform('web') && setVisible(true);
    (_d = (_c = (_b = (_a = carouselCardRef === null || carouselCardRef === void 0 ? void 0 : carouselCardRef.current) === null || _a === void 0 ? void 0 : _a.modalRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.open) === null || _d === void 0 ? void 0 : _d.call(_c);
    (actionCtaProps === null || actionCtaProps === void 0 ? void 0 : actionCtaProps.onActionCtaPress) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(actionCtaProps === null || actionCtaProps === void 0 ? void 0 : actionCtaProps.onActionCtaPress, Object.assign({}, actionCtaProps)));
  };
  var onCalendarClose = () => {
    var _a, _b, _c, _d;
    (_d = (_c = (_b = (_a = carouselCardRef === null || carouselCardRef === void 0 ? void 0 : carouselCardRef.current) === null || _a === void 0 ? void 0 : _a.modalRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.close) === null || _d === void 0 ? void 0 : _d.call(_c);
  };
  var changeSelectedDate = (event, currentSelectedDate) => {
    var _a;
    if (typeof currentSelectedDate === 'number' && isNaN(currentSelectedDate) && currentSelectedDate != undefined) {
      var clearedCarousel = clearCarousel(carousel);
      setCarousel(clearedCarousel);
      onClearPressMetadata && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(onClearPressMetadata, {
        isDisabled: true
      }));
    }
    var shouldCarouselUpdate = checkMinAndMaxDate(currentSelectedDate, actionCtaProps === null || actionCtaProps === void 0 ? void 0 : actionCtaProps.minimumDate, actionCtaProps === null || actionCtaProps === void 0 ? void 0 : actionCtaProps.maximumDate);
    if (shouldCarouselUpdate) {
      if ((event === null || event === void 0 ? void 0 : event.type) === CALENDAR_EVENTS.dismissed) {
        setDate(selectedDate);
        setVisible(false);
        return;
      }
      if ((event === null || event === void 0 ? void 0 : event.type) === CALENDAR_EVENTS.set) {
        setVisible(false);
      }
      var updatedCarousel = updateCarouselIsSelected(currentSelectedDate);
      setCarousel(updatedCarousel);
      setDate(currentSelectedDate);
      var newDate = (_a = new Date(currentSelectedDate)) === null || _a === void 0 ? void 0 : _a.toDateString();
      onCalendarItemPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(onCalendarItemPressMetaData, {
        currentSelectedDate: currentSelectedDate,
        date: newDate
      }));
      onCalendarClose();
    } else {
      if ((event === null || event === void 0 ? void 0 : event.type) === CALENDAR_EVENTS.dismissed) {
        setVisible(false);
      }
      return;
    }
  };
  var updateCarouselIsSelected = selectedValue => {
    return carousel === null || carousel === void 0 ? void 0 : carousel.map((carouselItem, carouselIndex) => {
      var _a, _b, _c;
      var isDateSame = checkIfDateAreSame(selectedValue, carouselItem.value);
      if (isDateSame) {
        carouselItem.isSelected = true;
        setSelectedCarousel(carouselItem);
        setSelectedCarouselIndex(carouselIndex);
        (_c = (_b = (_a = carouselCardRef === null || carouselCardRef === void 0 ? void 0 : carouselCardRef.current) === null || _a === void 0 ? void 0 : _a.carouselRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.scrollToIndex({
          animated: true,
          index: carouselIndex
        });
      } else {
        carouselItem.isSelected = false;
      }
      return carouselItem;
    });
  };
  return _jsxs(View, Object.assign({}, getTestId(testID), restProps, {
    children: [_jsx(SchedulingCarouselCard, {
      ref: carouselCardRef,
      carousel: carousel,
      onSelectCarousel: onSelectCarousel,
      title: title,
      visible: visible,
      showActionCta: showActionCta,
      actionCtaProps: actionCtaProps,
      onCalendarOpen: onCalendarOpen,
      selectedDate: selectedDate,
      changeSelectedDate: changeSelectedDate
    }), showSlotList && _jsx(SchedulingSlotListCard, {
      selectedCarousel: selectedCarousel,
      title: slotListTitle,
      onSelectSlot: onSelectSlot,
      callOutWidgetProps: callOutWidgetProps,
      onUserAction: onUserAction
    })]
  }));
};
SchedulingWidgetComponent.genericRendererKey = 'AirSchedulingWidget';